import * as React from 'react';
import { ThemeContext } from 'styled-components';

import Box from '../Layout/Box';
import Text from '../Typography/Text/Text';

import { IICircleProgressCommon } from './common';

const CircleProgressLabel: React.FC<IICircleProgressCommon> = ({ percentage, label }) => {
  const LabelContainer = Box;
  const PercentageNumber = Text;
  const PercentageSign = Text;
  const ContentText = Text;
  const { themeTwo: { circleProgress }, ...rest } = React.useContext(ThemeContext);

  // fix for amount font only remove once rebrand happens
  const isAmount = rest.name === 'amount' || rest.name === 'amountDark';
  const margin = isAmount ? { top: '0.75x' } : undefined;

  return (
    <LabelContainer
      height='100%'
      width='100%'
      justifyContent='center'
      alignItems='center'
      direction='column'
      position={{ type: 'absolute', top: '0', right: '0' }}
      margin={margin}
    >
      <PercentageNumber {...circleProgress.label.percentage.number}>
        {percentage}
        <PercentageSign {...circleProgress.label.percentage.sign}>%</PercentageSign>
      </PercentageNumber>
      <ContentText {...circleProgress.label.content}>{label}</ContentText>
    </LabelContainer>
  );
};

export default CircleProgressLabel;
